const admins = [
  'ankit.sharma1@autodesk.com',
  'Boris.Rabinovich@autodesk.com',
  'dave.fagerstrom@autodesk.com',
  'david.becroft@autodesk.com',
  'namra.solanki@autodesk.com',
  'philip.huynh@autodesk.com',
  'michael.oliver@autodesk.com',
  'dmitry.brumberg@autodesk.com',
  'fuming.dai@autodesk.com',
  'joshua.ledwell@autodesk.com',
  'phil.xia@autodesk.com',
  'xiaolong.zheng@autodesk.com',
  'hongna.li@autodesk.com', // Materials team
  'bobby.zhou@autodesk.com', // Materials team
];

export default admins;
